;(function($, window, document){
    window.Filter = Me.view.extend({
        options: {

        },

        initialize: function() {
            _.bindAll(this, 'selectFilter');

            this.addEvents();
        },
        addEvents: function() {
            this.$el.find('.filter').on('click', this.selectFilter);
        },
        selectFilter: function(e){
            if(!$(e.currentTarget).hasClass('active')){
                var filter = $(e.currentTarget).attr('data-category').toString();
                this.$('.filter.active').removeClass('active');
                $(e.currentTarget).addClass('active');
                Me.dispatch.emit('filter.selected', this, {filter: filter});
            }
        }
    });
}(jQuery, window, document));
